import angular from 'angular';

angular
  .module('cxSettings')
  .controller('InsertWorkflowActionDialogCtrl', [
    '$element',
    '$http',
    '$state',
    'appUrls',
    'flySvc',
    'close',
    insertWorkflowActionDialogCtrl,
  ]);

function insertWorkflowActionDialogCtrl($element, $http, $state, appUrls, flySvc, close) {
  var vm = this;
  var EMAIL_ACTION_WORKFLOW_TYPE = 161;

  vm.loading = true;
  vm.configurations = [];
  vm.selectedConfig = null;
  vm.buttonText = '';
  vm.selectedColor = '#5cb85c';
  vm.colors = ['#5cb85c', '#337ab7', '#6c757d', '#d9534f'];

  vm.goToActionWorkflows = function() {
    $element.modal('hide');
    close(null, 500);
    $state.go('settings.workflowConfiguration', { tab: 'actions' });
  };

  $http
    .get(appUrls.api + '/api/workflowConfiguration')
    .then(function(response) {
      vm.configurations = response.data
        .filter(x => x.workflowType === EMAIL_ACTION_WORKFLOW_TYPE)
        .map(x => ({
          ...x,
        }));
    })
    .catch(function(error) {
      flySvc.error(error.data.code, error.data.parameters);
    })
    .finally(function() {
      vm.loading = false;
    });

  vm.save = function() {
    if (!vm.selectedConfig) return;
    $element.modal('hide');
    close({ config: vm.selectedConfig, color: vm.selectedColor, buttonText: vm.buttonText }, 500);
  };

  vm.cancel = function() {
    close(null, 500);
  };
}
